<template>
	<form>
		<div class="vx-row" v-if="product.check_price">
			<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
				<vs-input label="Minimale prijs" type="number" v-validate="'required'" name="min_price"
						  v-model="product.min_price"></vs-input>
				<span class="text-danger text-sm" v-show="errors.has('min_price')">{{
						errors.first('min_price')
					}}</span>
			</div>
			<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
				<vs-input label="Maximale prijs" type="number" v-validate="'required'" name="max_price"
						  v-model="product.max_price"></vs-input>
				<span class="text-danger text-sm" v-show="errors.has('max_price')">{{
						errors.first('max_price')
					}}</span>
			</div>
			<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
				<vs-input label="verschil in euros" type="number" v-validate="'required'"
						  name="diffrence_in_euro"
						  v-model="product.diffrence_in_euro"></vs-input>
				<span class="text-danger text-sm"
					  v-show="errors.has('diffrence_in_euro')">{{
						errors.first('diffrence_in_euro')
					}}</span>
			</div>
			<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
				<vs-input label="Product pagina url" v-validate="'required|url'" name="product_page_url"
						  v-model="product.product_page_url"></vs-input>
				<span class="text-danger text-sm"
					  v-show="errors.has('product_page_url')">{{
						errors.first('product_page_url')
					}}</span>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full">
				<br>
				<vs-checkbox v-model="product.check_price">Automatische prijs controle ingeschakelen*</vs-checkbox>
			</div>
			<div class="vx-col w-full">
				<p style="font-size: 9px;">*Let op, het gebruik van prijs controle brengt extra kosten met zich mee</p>
			</div>
		</div>
	</form>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';
import {mapActions} from 'vuex';

Vue.use(VeeValidate);
const dict = {
	custom: {
		min_price: {
			required: 'Voer hier je minimale product prijs in',
		},
		max_price: {
			required: 'Voer hier je maximale product prijs in',
		},
		diffrence_in_euro: {
			required: 'Voer hier het prijs verschil in',
		},
		product_page_url: {
			required: 'Voer hier je product pagina link in',
			url: 'Dit is geen geldige link',
		},
	},

};
Validator.localize('en', dict);
export default {
	name: 'priceControl',
	props: {
		product: {},
	},
	data() {
		return {
			updatedProduct: {},
		}
	},
	methods: {
		...mapActions({
			getProducts: 'productStore/getProducts',
			updateProduct: 'productStore/updateProducts',
		}),
		validate() {
			let valid = true;
			if (!this.product.check_price) {
				this.update()
			} else {
				if (parseInt(this.product.min_price) >= parseInt(this.product.max_price)) {
					valid = false;
					this.$vs.notify({
						title: 'Error',
						text: 'De maximale prijs moet hoger zijn dan de minimale prijs',
						color: 'danger'
					});
				}
				this.$validator.validateAll().then(result => {
					if (!result) {
						valid = false;
						this.$vs.notify({
							title: 'Error',
							text: 'Controleer de gegevens en probeer opnieuw',
							color: 'danger'
						});
					}
				});
				if (valid) {
					this.update()
				}
			}
		},
		update() {
			if (this.product.check_price) {
				const active = {
					product_id: this.product.id,
					check_price: this.product.check_price,
					min_price: this.product.min_price,
					max_price: this.product.max_price,
					diffrence_in_euro: this.product.diffrence_in_euro,
					product_page_url: this.product.product_page_url,
				};
				this.updatedProduct = active;
			} else {
				const notActive = {
					product_id: this.product.id,
					check_price: this.product.check_price,
				};
				this.updatedProduct = notActive;
			}
			this.updateProduct(this.updatedProduct).then(result => {
				this.getProducts();
				this.$vs.notify({
					title: 'Gelukt',
					text: 'Je wijzigingen zijn opgeslagen',
					color: 'success'
				});
			}).catch(error => {
				console.log(error);
				this.$vs.notify({
					title: 'Error',
					text: 'Er is iets mis gegaan, probeer het opnieuw',
					color: 'danger'
				});
			});
		}
	}
}
</script>
